<template>
  <!-- Modal -->
  <div class="modal fade" id="SingleReturnsModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">
            セット品をバラす
<!--             <span class="text-primary ml-3">
              <template v-for="item in $props.orderTypeNum">
                {{ item.type_number + '\t' }}
              </template>
            </span> -->
          </h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <table class="table table-striped table-align-middle">
            <thead>
              <tr>
                <th>型番</th>
                <th>個数</th>
              </tr>
            </thead>
            <tbody class="nowrap">
              <template v-for="(item, i) in $props.setItems">
                <tr :key="i">
                  <td>{{ item.model }}</td>
                  <td></td>
                </tr>
                <template v-for="(child, j) in item.children">
                  <tr :key="'child' + i + '' + j">
                    <td style="padding-left:4em;">{{ child.model }}</td>
                    <td>{{ child.quantity }}</td>
                  </tr>
                </template>
              </template>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button ref="closeModal" type="button" class="btn btn-secondary" data-dismiss="modal">閉じる</button>
          <button @click="seprateProducts()" type="button" class="btn btn-primary">確定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SingleReturnModal',
  props: ['return_id', 'setItems', 'returnDetails'],
  data () {
    return {
    }
  },
  created () {},
  methods: {
    seprateProducts () {
      this.setItems.forEach(parent => {
        parent.children.forEach(child => {
          const detail = JSON.parse(JSON.stringify(child))
          detail.is_not_billing = 1
          detail.return_status_id = 1
          detail.return_state_id = 1
          detail.return_reason_id = 0
          detail.replacement_status_id = 1
          detail.replacement_state_id = 1
          detail.replacement_reason_id = 0
          detail.test_result = null
          detail.remarks = null

          for (let i = 0; i < detail.quantity; i++) {
            const data = JSON.parse(JSON.stringify(detail))
            data.quantity = 1
            this.$props.returnDetails.push(data)
          }
        })

        const orgParant = this.$props.returnDetails.find(item => item.product_id === parent.product_id)
        orgParant.set_status = 2
      })
      this.$toastr.info('セット品をバラしました。', 'Information', { timeOut: 10000 })
      this.$refs.closeModal.click()
    }
  }
}
</script>
